import React from 'react';
import { LocalFooter } from '../local/LocalLayout';
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const localPaths = ['/for-local-businesses', '/pricing', '/how-it-works', '/repupgrade-ai', '/playground', '/create-access'];
  if (localPaths.includes(location.pathname) || location.pathname.startsWith('/ai-team/')) return <LocalFooter />;
  const isAgencyPage =
    location.pathname === '/agencies'
    || location.pathname === '/resources'
    || location.pathname === '/agency-how-it-works'
    || location.pathname === '/repupgrade-in-action'
    || location.pathname === '/partners'
    || location.pathname === '/partner-fit'
    || location.pathname === '/partner-onboarding'
    || location.pathname === '/partner-access'
    || location.pathname === '/partner-discovery'
    || location.pathname === '/certified-partner'
    || location.pathname === '/white-label'
    || location.pathname.startsWith('/agency-ai-team/');
  const homeDestination = isAgencyPage ? '/agencies' : '/';

  return (
    <footer className="bg-white border-t border-gray-100 pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12">
          <Link to={homeDestination} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img
              src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/14d14dc0100011f20de8b02234a5b726.png"
              alt="RepUpgrade Logo"
              className="w-10 h-10 object-contain"
            />
            <span className="font-lexend font-bold text-xl tracking-tight text-[#101F1F]">RepUpgrade</span>
          </Link>

          <div className="flex items-center gap-6">
            <a
              href="https://www.digitalcowboy.io/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 text-sm font-medium text-[#101F1F]/60 hover:text-[#409FA1] transition-all"
            >
              <div className="w-10 h-10 rounded-xl bg-[#F7F8F7] border border-gray-100 flex items-center justify-center group-hover:border-[#409FA1]/30 transition-colors shadow-sm">
                <img
                  src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/ae915464e71886af73cf699f1c9feef1.png"
                  alt="Digital Cowboy Logo"
                  className="w-6 h-6 object-contain grayscale group-hover:grayscale-0 transition-all"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-[10px] uppercase tracking-tighter text-gray-400">Architected by</span>
                <span className="font-bold">Digital Cowboy</span>
              </div>
            </a>
          </div>
        </div>

        {isAgencyPage && <nav aria-label="Footer resources" className="mb-8 flex flex-wrap justify-center gap-6 text-sm font-semibold text-[#244A49]"><Link to="/">Choose your path</Link><Link to="/agency-how-it-works">How It Works</Link><Link to="/pricing">Business Plans</Link><Link to="/partners">Partner Options</Link><Link to="/white-label">White Label Partner</Link><Link to="/resources">Resources</Link><a href="https://www.digitalcowboy.io/ai-mastermind/">AI Mastermind ↗</a></nav>}
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-xs font-medium text-[#101F1F]/50 border-t border-gray-50 pt-8">
          <Link to="/privacy" className="hover:text-[#409FA1] transition-colors">Privacy Policy</Link>
          <Link to="/cookies" className="hover:text-[#409FA1] transition-colors">Cookie Policy</Link>
          <Link to="/terms" className="hover:text-[#409FA1] transition-colors">Terms of Service</Link>
          <Link to="/dpa" className="hover:text-[#409FA1] transition-colors">DPA</Link>
          <a href="https://bountyhunter.repupgrade.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#409FA1] transition-colors">
            Affiliate Program
          </a>
        </div>

        <div className="text-center mt-12 space-y-4">
          <div className="text-[10px] text-[#101F1F]/20">
            &copy; {new Date().getFullYear()} RepUpgrade. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}